export default {
  methods: {
  },
};



// WEBPACK FOOTER //
// ./src/mixins/global-methods.js